import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { validateRFC, getErrorsMessage } from '../utils.js';
import Dropzone from 'react-dropzone'
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
class ProviderInvitation extends Component {
    constructor(props) {
        super();

        this.onDrop = (files) => {
            this.setState({ file: files[0] });
            this.validateSendFile()
            this.setState({files})
          };


        this.state = {
            invitationType:'manual',
            errors: 0,
            files: [],
            file:'',
            country_id:'',
            name: '',
            email: '',
            rfc: '',
            disabled:true,
            providers: [],
            successFile:false,
            excelProviders: [],
            message: '',
            dossierId: null,
            dossiers: [],
            dossierDocuments: [],
            aditionalDocuments:[],
            documents: [],
            page: 1,
            total: 0,
            maxRecords: 10,
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.save = this.save.bind(this)
        this.changeDossiers = this.changeDossiers.bind(this)
        this.handleNameChange = this.handleNameChange.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handleRFCChange = this.handleRFCChange.bind(this)
        this.handleMessageChange = this.handleMessageChange.bind(this)
        this.removeProvider = this.removeProvider.bind(this);
        this.rfc = React.createRef()
        this.dossier = React.createRef()
    }


    async componentDidMount() {
        await this.getDossiers()
        await this.getUser()
        FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                dossier_id: {
                    validators: {
                        notEmpty: {
                            message: 'Tipo de expediente requerido'
                        },
                        greaterThan: {
                            min: 1,
                            message: 'Selecciona un tipo de expediente'
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        }).on('core.form.valid', () => {
            if(this.state.invitationType == 'manual'){
                if (this.state.providers.length > 0) {
                    this.save();
                } else {
                    toastr.error("Debes ingresar al menos un invitado");
                }
            }
            if(this.state.invitationType == 'masivo'){
                if (this.state.errors == 0) {
                    this.save();
                } else {
                    let errorList = '<table class="table table-striped"><tbody><thead><th>Email Registrado</th><th>Email</th><th>RFC</th></thead>'
                    for(let i = 0; i < this.state.excelProviders.length; i++){
                        if(this.state.excelProviders[i].message){
                            errorList += '<tr>'
                            errorList +=    '<td>'+this.state.excelProviders[i].email  + '</td>';
                            errorList +=  '<td>'+this.state.excelProviders[i].new_email  + '</td>';
                            errorList +=   '<td>'+this.state.excelProviders[i].rfc  + '</td>';
                            errorList += '</tr>'
                        }
                    }
                    errorList = errorList + '</tbody></table>'

                    Swal.fire({
                        title: 'Hay algunos RFC’s que deseas invitar que ya se encuentran registrados con otros email. Revisa la lista a continuación:',
                        icon: 'error',
                        width: '800px',
                        html: errorList,
                        showCloseButton: true,
                        showCancelButton: true,
                        focusConfirm: false,
                        confirmButtonText:'Aceptar',
                        cancelButtonText:'Cancelar',
                      }).then((result) => {
                        if (result.isConfirmed) {
                                this.save();
                            }
                        })
                    }
                }
            });
        let fv
        fv = FormValidation.formValidation(KTUtil.getById('frmProvider'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre debe tener una longitud mínima de 4'
                        },
                    }
                },
                email: {
                    validators: {
                        notEmpty: {
                            message: 'Email requerido'
                        },
                        emailAddress: {
                            message: 'Email incorrecto'
                        },
                    }
                },
                rfc: {
                    validators: {
                        notEmpty: {
                            message: 'RFC requerido'
                        },
                        stringLength: {
                            min: 8,
                            max: 13,
                            message: 'RFC incorrecto'
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        }).on('core.form.valid', () => {
            this.setState({ disabled: false })
            this.validateProviderInformation();
        });
        if(this.state.country_id == 2){
            fv.disableValidator('rfc');
        }
    }

    getUser = async () => {
        const userInfo = await axios.get(`/api/account`)
        if(userInfo.status == 200){
            const { id, name, person_type, rfc, fiscal_name, address1, address2, address3, zipcode, municipality_id, municipio, logo_path, country_id,state_colombia,municipio_colombia} = userInfo.data
            this.setState({ country_id: country_id })
        }
    }

    isChecked = (e)=>{
        for(let i=0; i<this.state.aditionalDocuments.length; i++){
            if(this.state.aditionalDocuments[i].id == e.id){
                return true;
            }
        }
    }
    handleTypeChange = (e)=>{
        this.setState({ errors: 0 })
        this.setState({ providers: [] })
        this.setState({ successFile: false })
        this.setState({ disabled: true })
        this.setState({ invitationType: e.target.value })
    }

    handleChange(e){
        this.setState({documents: [], search: e.target.value, page: 1}, function () {
            this.getDocuments();
        });
    }

    updateStateList(e, value){
        if (e.target.checked){
            this.setState({
                aditionalDocuments: this.state.aditionalDocuments.concat([value])
            })
            } else {
            this.setState({
                aditionalDocuments : this.state.aditionalDocuments.filter(function(val)
                    {
                        return val.id!==value.id
                    }
                )
            })
        }
    }

    async getDocuments() {
        this.setState({
            documents: []
        })
        var url = '/api/documents/aditional';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('dossier_id', this.state.dossierId)
        query.append('maxRecords', this.state.maxRecords)
        const qs = query.toString();
        const res =  await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({documents: data, total: res.data.total});
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getDocuments();
        });
    }

    handleNameChange(e) {
        this.setState({ name: e.target.value });
    }

    handleEmailChange(e) {
        this.setState({ email: e.target.value });
    }

    handleRFCChange(e) {
        if (validateRFC(e.target.value)) {
            this.rfc.current.classList.remove('is-invalid')
        } else {
            this.rfc.current.classList.add('is-invalid')
        }
        this.setState({ rfc: e.target.value });
    }


    handleMessageChange(e) {
        this.setState({ message: e.target.value });

    }

    printLine(providers) {
        return  providers.map((p, i) => {
                return (
                        <tr key={i} >
                            <td>{i +  1}</td>
                            <td>{ p.rfcError ?
                                    <span className="svg-icon svg-icon-danger">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"   >
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"/>
                                            <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                                            <path d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z" fill="#000000"/>
                                        </g>
                                        </svg> {p.rfc}
                                    </span>
                                    : p.message ? p.message:
                                    <span className="svg-icon svg-icon-info">
                                            <svg xmlns="http://www.w3.org/2000/svg"   width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <polygon points="0 0 24 0 24 24 0 24"/>
                                                <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="#000000" fillRule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "/>
                                            </g>
                                            </svg> {p.rfc}
                                    </span>
                                }
                            </td>
                            <td>{ p.emailError ?
                                    <span className="svg-icon svg-icon-danger">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"   >
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"/>
                                            <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                                            <path d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z" fill="#000000"/>
                                        </g>
                                        </svg>
                                    </span> :
                                    <span className="svg-icon svg-icon-info">
                                        <svg xmlns="http://www.w3.org/2000/svg"   width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <polygon points="0 0 24 0 24 24 0 24"/>
                                            <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="#000000" fillRule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "/>
                                        </g>
                                        </svg>
                                    </span>
                                } {p.email}
                            </td>
                        </tr>
                    )
                })
    }


    async handleExcelChange(e){
       this.state.errors = 0
       let file = e.target.files[0]
       await this.setState({ file: file });
       this.validateExcelProviderInformation()

    }

    async getDossiers() {
        const res = await axios.get('/api/dossiers')
        this.setState({dossiers: res.data.data})
    }

    async getDossierDocuments(documentId) {
        const res = await axios.get('/api/dossiers/' + documentId)
        this.setState({dossierDocuments: res.data.documents})
    }

    changeDossiers(event) {
        this.setState({
            aditionalDocuments: []
        })
        const dossierId = event.target.value
        if (dossierId == 0) {
            this.setState({dossierId: null, dossierDocuments: []})
        } else {
            this.dossier.current.classList.remove('is-invalid')
            this.setState({dossierId: dossierId})
            this.getDossierDocuments(dossierId)
        }
	}

    async save() {
        KTUtil.btnWait(KTUtil.getById('btnSubmit'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        let params
        if(this.state.invitationType == 'manual'){
            params = JSON.stringify({
                providers: this.state.providers,
                message: this.state.message,
                dossier_id: this.state.dossierId,
                aditionalDocuments: this.state.aditionalDocuments,
            })
        }
        if(this.state.invitationType == 'masivo'){
            params = JSON.stringify({
                providers: this.state.excelProviders,
                message: this.state.message,
                dossier_id: this.state.dossierId,
                aditionalDocuments: this.state.aditionalDocuments,
            })
        }
        await axios.post(
            '/api/persons/invitation',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/';
            });
        })
        .catch((error) => {
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    removeProvider(index) {
        const providers = [...this.state.providers];
        providers.splice(index, 1);
        this.setState({ providers: providers });
    }

    validateSendFile(){
        let formData = new FormData()

        formData.append('file',this.state.file)

        axios.post(
            '/api/providers/validate_excel_information',formData
        ).then((providers) => {
            toastr.success("Documento cargado");
            if(providers.data.errors == 0){
                this.setState({ disabled: false })
                this.setState({ successFile: true });
            }else{
                this.setState({ disabled: true })
                this.setState({ successFile: false });
            }
            this.setState({ excelProviders: providers.data.providers, errors: providers.data.errors });
        })
    }


     validateExcelProviderInformation() {
        let formData = new FormData()

        formData.append('file',this.state.file)

        axios.post(
            '/api/providers/validate_excel_information',formData
        ).then((providers) => {
            toastr.success("Documento cargado");
           // this.setState({ excelProviders: providers.data.providers, errors: providers.data.errors });
        })
    }

    async validateProviderInformation() {
        await axios.get(
            '/api/providers/validate_information?rfc=' + this.state.rfc + '&email=' + this.state.email,
        ).then(() => {
            this.addProvider();
        })
        .catch((error) => {
            const message = getErrorsMessage(error);

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(() => {
                this.setState({
                    email: error.response.data['email'],
                });

                this.addProvider();
            });
        });
    }

    addProvider() {
        const p = {
            name: this.state.name,
            email: this.state.email,
            rfc: this.state.rfc,
        };

        this.setState(prevState => ({
            providers: [...prevState.providers, p],
            name: '',
            email: '',
            rfc: '',
        }));
    }



    render() {
        const files = this.state.files.map(file => (
            <li key={file.name}>
              {file.name} - {file.size} bytes
            </li>
          ));
        return (
            <div>
                <div className="d-flex flex-column-fluid">
                    <div className="container d-flex">
                        <div   className={ this.state.invitationType == 'manual'? 'col-md-2  font-size-h4 selectedRadio'  : 'col-md-2 font-size-h5 text-dark'}>
                            <input type="radio" value="manual" checked={this.state.invitationType == 'manual'} onChange={this.handleTypeChange}/> Carga Manual
                        </div>
                        <div className={ this.state.invitationType == 'masivo'? 'col-md-2  font-size-h4 selectedRadio' : 'col-md-2 font-size-h5 text-dark '}>
                            <input type="radio" value="masivo" checked={this.state.invitationType == 'masivo'} onChange={this.handleTypeChange}/> Carga Masiva
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column-fluid mt-6">
                    <div className="container">
                        <div className="card card-ustom gutter-b">
                            <div className="card-body">
                                <h5 className="text-dark font-weight-bold mb-10">
                                    Datos del invitado
                                    <br/>
                                    <small className="text-muted font-weight-bold">Añade los campos que requieres que el nuevo invitado ingrese</small>
                                </h5>
                                <div className={ this.state.invitationType == 'manual'? 'show' : 'd-none'}>
                                    <form id="frmProvider">
                                        <div className="row justify-content-center text-left">
                                            <div className="col-sm-4 align-self-center form-group">
                                                <label className="text-left">Nombre</label>
                                                <input id="name" type="text" className="form-control form-control-solid" name="name" value={this.state.name} autoFocus onChange={this.handleNameChange}/>
                                            </div>
                                            <div className="col-sm-4 align-self-center form-group">
                                                <label className="text-left">Email</label>
                                                <input id="email" type="email" className="form-control form-control-solid" name="email" value={this.state.email} onChange={this.handleEmailChange}/>
                                            </div>
                                            <div className="col-sm-3 align-self-center form-group">
                                                <label className="text-left">RFC/RUT</label>
                                                <input ref={this.rfc} id="rfc" type="text" className="form-control form-control-solid" name="rfc" value={this.state.rfc} onChange={this.handleRFCChange}/>
                                            </div>
                                            <div className="col-sm-1 align-self-center form-group">
                                                <label className="text-left">&nbsp;</label>
                                                <div>
                                                    <button type="submit" onClick={(e) => this.guardar()} className="btn btn-sm btn-primary text-white">
                                                        Agregar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={ this.state.invitationType == 'masivo'? 'show' : 'd-none'}>

                                    <p>En caso de que no cuentes con la plantilla, favor de dar <a href="/assets/media/template/PlantillaInvitacion.xlsx">click aqui</a> para descargarla</p>
                                    <Dropzone onDrop={this.onDrop}>
                                        {({getRootProps, getInputProps}) => (
                                            <section className="  mb-6">
                                                <div {...getRootProps({className: 'excelDrop'})}>
                                                <input {...getInputProps()} />
                                                <p>Suelta los archivos aquí o haz clic para subirlos.</p>
                                                {this.state.successFile == true ? <div class="alert alert-success" role="alert">El archivo se ha subido correctamente y no contiene errores</div> : null}
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                </div>
                                <div>
                                <div className={ this.state.errors == 0 ? 'd-none ' : 'd-flex flex-wrap error-container mb-5'}   >
                                    <div className="col-sm-7">
                                    <span className="svg-icon svg-icon-danger">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"   >
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"/>
                                            <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                                            <path d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z" fill="#000000"/>
                                        </g>
                                        </svg>
                                    </span>
                                        El archivo contiene varios errores los cuales se muestran a continuación:</div>
                                    { this.state.excelProviders.length > 0 && <div className="col-sm-5 text-right text-dark-75 font-weight-bolder mb-1 font-size-lg">
                                    <span className="text-primary"> { this.state.excelProviders.length} </span> contactos cargados /
                                    <span className="text-danger"> { this.state.errors} </span> con errores</div> }
                                    <div className="col-sm-12">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                <th>Fila</th>
                                                <th>Error en RFC/RUT</th>
                                                <th>Error en Email</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { this.printLine(this.state.excelProviders) }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                </div>
                            {this.state.providers.map((p, i) => {
                            return <div key={i} className="row justify-content-center text-left form-group">
                                <div className="col-sm-4 align-self-center">
                                    <label className="text-left">{p.name}</label>
                                </div>
                                <div className="col-sm-4 align-self-center">
                                    <label className="text-left">{p.email}</label>
                                </div>
                                <div className="col-sm-3 align-self-center">
                                    <label className="text-left">{p.rfc}</label>
                                </div>
                                <div className="col-sm-1 align-self-center">
                                    <button type="button" className="btn btn-sm btn-link-danger" onClick={(e) => this.removeProvider(e, i)}>
                                        Eliminar
                                    </button>
                                </div>
                                { p.message ? <div className="col-sm-12 align-self-center text-danger"> {p.message}</div> : ''}
                            </div>
                        })}
                            <form id="frm">
                                <div className="row justify-content-center text-left">
                                    <div className="col-sm-6 align-self-center form-group">
                                        <label className="text-left">Plantilla de expediente</label>
                                        <select ref={this.dossier} className="form-control form-control-solid" id="dossier_id" name="dossier_id" onChange={this.changeDossiers}>
                                            <option value="0">--Seleccionar--</option>


                                        </select>
                                    </div>
                                    <div className="col-sm-6 align-self-center form-group">
                                        <div className="mt-0 mt-sm-8">
                                            <label>{ this.state.dossierId != null ? "Hay " + this.state.dossierDocuments.length + " documentos en esta plantilla de expediente" : "" }</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <label className="text-left">Listado de documentos a solicitar</label>
                                        <div className="col-12 pt-6 pb-2 pr-6 pl-6 card bg-light-light min-h-200px">
                                            {this.state.dossierDocuments.map((d, i) => {
                                                return <div key={i} className="mb-2"><span className="fas fa-check text-primary"></span>&nbsp; {d.title}</div>
                                            })}
                                            { this.state.aditionalDocuments.length > 0  ?
                                            <div><hr/>
                                            <label className="text-left text-left text-dark font-weight-bold">Listado de documentos adicionales</label></div>
                                            : "" }
                                            {this.state.aditionalDocuments.map((d, i) => {
                                                return <div key={i} className="mb-2"><span className="fas fa-check text-primary"></span>&nbsp; {d.title}</div>
                                            })}
                                            { this.state.dossierId != null ?
                                            <div className="text-center mt-6">
                                                <a href="" onClick={this.getDocuments.bind(this)} className="btn btn-success btn-sm font-weight-bolder px-5" data-toggle="modal" data-target="#modal">
                                                    <span className="svg-icon svg-icon-md">
                                                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                                <polygon points="0 0 24 0 24 24 0 24"/>
                                                                <path d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
                                                                <rect fill="#000000" x="6" y="11" width="9" height="2" rx="1"/>
                                                                <rect fill="#000000" x="6" y="15" width="5" height="2" rx="1"/>
                                                            </g>
                                                        </svg>
                                                    </span>
                                                    Agregar Nuevo Documento
                                                </a>
                                            </div>
                                            : "" }

                                            { this.state.dossierId != null ?
                                            <div className="modal fade" id="modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                                                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">

                                                    <div className="modal-content" style={{ background: '#f5f5f5' }}>
                                                        <div className="modal-body px-15 py-10">
                                                            <h5 className="text-dark font-weight-bold my-1 mr-5">Solicitar nuevos documentos</h5>
                                                            <div className="text-muted">Selecciona los nuevos documentos que serán agregados a este expediente</div>

                                                            {/* <div className="row justify-content-end">
                                                                <div className="col-4">
                                                                    <div className="input-icon">
                                                                        <input name="search"type="text" className="form-control" placeholder="Buscar mis expedientes" />
                                                                        <span>
                                                                            <i className="flaticon2-search-1 text-primary icon-md"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>*/}

                                                            <div className="card card-custom gutter-b my-5">
                                                                <div className="card-body pt-5">
                                                                    {this.state.documents.map((o, i) => {
                                                                        return <div key={i}>
                                                                            <div className="d-flex align-items-center py-2">
                                                                                <div className="symbol symbol-40 symbol-white">
                                                                                    <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                                                                    <div className="checkbox-inline mr-5">
                                                                                        <label className="checkbox checkbox-outline mb-2">
                                                                                            <input key={o}
                                                                                            name='list'
                                                                                            type='checkbox'
                                                                                            defaultChecked={this.isChecked(o)}
                                                                                            onClick={(e)=>this.updateStateList(e,o)}
                                                                                            label='Add'
                                                                                            className='listTour'/>
                                                                                            <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                                                        </label>
                                                                                    </div>
                                                                                    </span>
                                                                                </div>
                                                                                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                                                                                    <a href={"/documents/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>{o.title}</a>
                                                                                    {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                                                                </div>
                                                                                <a href={"/documents/" + o.id + "/edit"}>
                                                                                    <button className="btn btn-icon btn-light btn-xs">
                                                                                        <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                                                                    </button>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    })}
                                                                </div>
                                                                {this.state.total > this.state.maxRecords  &&
                                                                    <SimplePagination
                                                                    updateCurrentPage={this.updateCurrentPage}
                                                                    currentPage={this.state.page}
                                                                    totalFiles={this.state.total}
                                                                    split={this.state.maxRecords} />
                                                                }
                                                            </div>

                                                            <br />

                                                            <div className="text-center">
                                                                <button data-dismiss="modal" className="btn btn-success font-weight-bolder px-10" >
                                                                    Cerrar
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            : "" }

                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="text-left">Mensaje personalizado</label>
                                        <textarea rows="10" placeholder="Da de alta tu mensaje" id="mensaje_personalizado" className="form-control form-control-solid" name="mensaje_personalizado" value={this.state.message} onChange={this.handleMessageChange}></textarea>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>
                        <div className="row justify-content-end mt-6">
                            <div className="col-sm-4 text-right">
                                <a href="/" className="btn btn-lg btn-secondary">
                                    Cancelar
                                </a>
                                <button id="btnSubmit" disabled={this.state.disabled} form="frm"  type="submit" className="btn btn-lg btn-primary ml-4 text-white">
                                    Enviar invitación
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProviderInvitation;

if (document.getElementById('ProviderInvitation')) {
    ReactDOM.render(<ProviderInvitation />, document.getElementById('ProviderInvitation'));
}
